export const ENV = {
  // API Configuration
  apiHost: process.env.REACT_APP_API_HOST,

  // Cognito Configuration
  cognitoRegion: process.env.REACT_APP_COGNITO_REGION,
  cognitoUserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  cognitoClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  cognitoDomain: process.env.REACT_APP_COGNITO_DOMAIN,
  callbackUrl: process.env.REACT_APP_CALLBACK_URL,

  // Application Stage
  stage: process.env.REACT_APP_STAGE,
};

// Derived helpers
export const isIntegration = ENV.stage === 'integration';
export const isLocal = ENV.stage === 'local';
export const isStaging = ENV.stage === 'staging';
export const isProduction = ENV.stage === 'production';
export const isTest = ENV.stage === 'test';
